import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import { useFreecodeContext, useAppContext } from 'hooks/useContext';
import {
  Container,
  CourseNameContainer,
  CourseName,
  Icon,
  RedirectIcon,
  CourseLessonsContainer,
  LessonContainer,
  LessonName,
  ModuleContainer,
} from './styles';
import { getConfig } from '../../../functions/getConfig';
const config = getConfig();

export default function FreecodeCourse({ course }) {
  let history = useHistory();
  const { exerciseId } = useParams();
  const { isDarkMode } = useAppContext();

  const { language, languageData } = useFreecodeContext();
  const [courseStructure, setCourseStructure] = useState({});

  useEffect(() => {
    let courseCopy = JSON.parse(JSON.stringify(course));
    var index = _.findIndex(courseCopy.syllabus, function (lesson) {
      if (lesson.exercise && String(lesson.exercise.id) === String(exerciseId)) return true;
      else {
        var exercises = _.pluck(lesson.modules, 'exercise');
        var exercisesId = _.pluck(exercises, 'id');
        var found = _.find(exercisesId, function (exercise) {
          return String(exercise) === String(exerciseId);
        });
        if (found) return true;
      }
    });
    courseCopy.active = true;
    courseCopy.syllabus[index].active = true;
    setCourseStructure(courseCopy);
  }, [course, exerciseId]);

  const setLessonActive = function (index, isCourse) {
    let courseCopy = JSON.parse(JSON.stringify(courseStructure));
    if (isCourse) courseCopy.active = !courseCopy.active;
    else courseCopy.syllabus[index].active = !courseCopy.syllabus[index].active;
    setCourseStructure(courseCopy);
  };

  const checkIsExerciseCompletedInLanguage = (values) =>
    _.every(_.pluck(values, 'isCompleted'), (value) => value === true);

  const redirectToExercise = (event, exerciseId, lessonIndex) => {
    if (lessonIndex >= 0)
      document.cookie =
        'course' +
        course._id +
        'Index=' +
        Number(lessonIndex) +
        '; Domain=' +
        config.COOKIE +
        '; Max-Age=2147483647; Path=/; SameSite=Lax';
    event.stopPropagation();
    history.push(`/exercise/${exerciseId}?courseId=${course._id}`);
  };

  const renderLessons = (lesson, index) => {
    return (
      <Container key={index} onClick={() => setLessonActive(index)}>
        <LessonContainer isDarkMode={isDarkMode}>
          <LessonName>{lesson.name}</LessonName>
          <Icon padding="0 8px 0 0" icon={lesson.active ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></Icon>
        </LessonContainer>
        {lesson.active &&
          lesson.modules.map((module, moduleIndex) => {
            return (
              <ModuleContainer
                key={moduleIndex}
                active={module.exercise.id === exerciseId}
                onClick={(e) => redirectToExercise(e, module.exercise.id, index)}
                isDarkMode={isDarkMode}
              >
                <Icon
                  padding="0 8px 0 0"
                  icon={
                    checkIsExerciseCompletedInLanguage(module.exercise.languagesCompleted[language])
                      ? 'fa fa-lg fa-check-circle-o'
                      : 'fa fa-lg fa-circle-o'
                  }
                ></Icon>
                {module.name}
              </ModuleContainer>
            );
          })}
      </Container>
    );
  };

  return (
    <Container isDarkMode={isDarkMode}>
      <CourseNameContainer isDarkMode={isDarkMode} onClick={() => setLessonActive(0, true)}>
        <CourseName>
          {`${courseStructure.name} (${languageData[language].SimpleName})`}
          <RedirectIcon isDarkMode={isDarkMode} href={`/courses/${course._id}`}></RedirectIcon>
        </CourseName>
        <Icon padding="0 8px 0 0" icon={courseStructure.active ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></Icon>
      </CourseNameContainer>
      {courseStructure.active && (
        <CourseLessonsContainer>
          {courseStructure.syllabus.map((syllabus, index) => renderLessons(syllabus, index))}
        </CourseLessonsContainer>
      )}
    </Container>
  );
}
